import ImagineFirstSection1 from '@/assets/img/imagine/first-section-1.jpg';
import ImagineFirstSection2 from '@/assets/img/imagine/first-section-2.jpg';
import ImagineMainImg from '@/assets/img/imagine/main.jpg';
import ImagineSecondSection1 from '@/assets/img/imagine/second-section-1.jpg';
import ImagineSecondSection2 from '@/assets/img/imagine/second-section-2.jpg';

import YourDreamFirstSection1 from '@/assets/img/yourDream/first-section-1.jpg';
import YourDreamFirstSection2 from '@/assets/img/yourDream/first-section-2.jpg';
import YourDreamMainImg from '@/assets/img/yourDream/main.jpg';
import YourDreamSecondSection1 from '@/assets/img/yourDream/second-section-1.jpg';
import YourDreamSecondSection2 from '@/assets/img/yourDream/second-section-2.jpg';

import ComeTrueFirstSection1 from '@/assets/img/comeTrue/first-section-1.jpg';
import ComeTrueFirstSection2 from '@/assets/img/comeTrue/first-section-2.jpg';
import ComeTrueMainImg from '@/assets/img/comeTrue/main.jpg';
import ComeTrueSecondSection1 from '@/assets/img/comeTrue/second-section-1.jpg';
import ComeTrueSecondSection2 from '@/assets/img/comeTrue/second-section-2.jpg';

export default {
  imagine: {
    main: 'Imagine being in a historical villa with huge windows facing the blue sky, a lovely breeze coming in through the open doors and flowing over your face. Nothing else there besides a magical crystalline sound in the background and your own heartbeat...',
    firstSection: [
      {
        title: 'La dolce vita',
        content: 'Thinking of Italy, the first thing that comes to mind is beauty.<br> Heritage and archaeology, amazing landscapes, a mesmerising blend of class and sophistication. Delicious food and wine, great people, a breathtaking coastline, mild temperatures and the typical "dolce far niente" attitude are what you can expect from our team.',
        img: ImagineFirstSection1,
      },
      {
        title: 'Exclusive venues',
        content: 'With a specialised focus on Lake Garda, Alessandra\'s hometown between Verona and Brescia, we will show you the most magnificent estates for your exclusive wedding. Lake Garda is a renowned location of refined class and elegance that is yet to be fully discovered.',
        img: ImagineFirstSection2,
      },
    ],
    mainImg: ImagineMainImg,
    secondSection: [
      {
        title: 'Lakeside',
        content: 'Imagine strolling inside a historical villa, its huge windows facing the blue sky, a lovely breeze coming in through the open doors and flowing over your face. On the horizon: Lake Garda. Around you, a symphony of chirping birds and rustling leaves.',
        img: ImagineSecondSection1,
      },
      {
        title: 'Tailor made',
        content: 'Each wedding is custom-built and personalised to your specifications. Think of a wave, which can be either a gesture of greeting or a body of water breaking on the shore. We are the same, something that appears and leaves its mark, only to then start all over again.',
        img: ImagineSecondSection2,
      },
    ],
  },
  yourDream: {
    main: 'For once in your life, you can have your dream day without anxiety or stress. Feel free to continue your everyday life and let us handle the rest.',
    firstSection: [
      {
        title: 'What’s your flair?',
        content: 'Your wedding is a celebration of you. Planning is about logistics and details and design is about discovery and creating your vision; weaving these two worlds together is what we most love to do! Choose the journey that suits you best!',
        img: YourDreamFirstSection1,
      },
      {
        title: 'Complete Planning Journey',
        content: 'This journey it is perfect for the couple who is busy working, far away and wants someone to “watch over” them and every detail. We begin by discussing your inspirations, dreams, and vision. From there, we create selections and details for your review, offer an optional site visit, provide continuous communication, and more often than not, become a listening ear and someone to continuously guide you along the way.',
        img: YourDreamFirstSection2,
      },
    ],
    mainImg: YourDreamMainImg,
    secondSection: [
      {
        title: 'Inclusions',
        content: 'Complete wedding planning<br>Custom Budget with assistance managing<br>Local oversight of venue and event details<br>Assist in finding and securing your venue<br>Wedding planning timeline and checklist<br>5x key planning meetings and unlimited email communication<br>Assist in hiring and management of all wedding vendors<br>Key vendor meetings',
        img: YourDreamSecondSection1,
      },
      {
        title: ' ',
        content: '1-2 x Venue visits<br>RSVP/Guest list and seating templates<br>Payment reminders and prompts<br>Create detailed day of timeline for bridal party and vendors<br>Vendor confirmations and coordination in final months<br>Wedding rehearsal coordination<br>Wedding day coordination<br>Final payment and tip distribution as directed by our couple<br><br>Investment: Euro 5,000 (Does not include hire items, florals or installations).',
        img: YourDreamSecondSection2,
      },
    ],
  },
  comeTrue: {
    main: 'You will enjoy the planning process, as much as your wedding day and maybe have a cappuccino or two while doing it!',
    firstSection: [
      {
        title: 'SAVOUR THE JOURNEY',
        content: 'You probably imagined what those days will look like: the loveliest ceremony ever surrounded by a stunning location, magnificent tables set with the greatest delicacies in the world, breathtaking lights, engaging music, memorable photos… You already know what you want and you don’t need a complete wedding journey! Take a look at this!',
        img: ComeTrueFirstSection1,
      },
      {
        title: 'Wedding Day Coordination',
        content: 'This journey is perfect for the couple who has it all done – has the venue(s), contracted the vendors, selected the décor and details – and wants to be able to celebrate worry-free. Eight weeks prior to your wedding day, we’ll review all the work you have already done and take over all the aspects being sure you can enjoy every minute of your wedding day without having to lift a finger.',
        img: ComeTrueFirstSection2,
      },
    ],
    mainImg: ComeTrueMainImg,
    secondSection: [
      {
        title: 'Inclusions',
        content: 'Unlimited phone and email communication eight weeks prior to your wedding day<br>Address any concerns you may have with vendors or logistics of the day<br>Vendor confirmation and coordination the month prior to your event and again, one week prior<br>Venue specific staff checklist<br>Create detailed day of timeline for bridal party and vendors<br>Coordination and management of the entire wedding day of<br>Oversee set up and breakdown of reception the day of<br>Direct the wedding party throughout the wedding day<br>Final payment and tip distribution as directed by our couple<br><br>Investment: Euro 1,500 (Does not include hire items, florals or installations)',
        img: ComeTrueSecondSection1,
      },
      {
        title: 'Wedding Design + Styling Journey',
        content: 'You know you want your wedding to be something your guests will never forget, just one problem, you don’t know where to start.This journey is perfect for you! We get to know you and how you want your day to feel. What you want your guests to remember and the elements most important to you, and then we present you with concepts. Once you pick the perfect concept, we dive into design briefs and curate a list of hand selected vendors. We work with renowned florists, graphic designers and hire companies to pull together a uniquely styled day, down to the cake knife! Every design is thoughtful and beautiful.',
        img: ComeTrueSecondSection2,
      },
    ],
    thirdSection: [
      {
        title: 'Inclusions',
        content: 'Full concept presentation<br>Complete design brief of chosen concept<br>Key vendor meetings (ie designer, florist, hire company)<br>1-2 Site inspections to ensure everything that needs to be designed has been thought about and included<br>Planning Meeting<br>Wedding Day execution with a full team onsite bringing your wedding mood board to life!<br><br>Investment: Euro 3,500 (Does not include hire items, florals or installations)',
        img: ImagineFirstSection1,
      },
    ],
  },
};
